import {put,takeLatest,call} from 'redux-saga/effects';
import * as userService from "../../../services/userService";
import {
    ADD_FAVORITE_VENUE,
    ADD_FAVORITE_VENUE_SUCCESS,
    ADD_FAVORITE_VENUE_ERROR,
}
    from "../../actions/user";

function* addFavoriteVenueSaga(action) {
    try {

        const data = yield call(userService.AddFavoriteVenue,action.payload)

        if(data)
            yield put({
                type: ADD_FAVORITE_VENUE_SUCCESS,
                payload: action.payload.venue
            });
        else
            yield put({
                type: ADD_FAVORITE_VENUE_ERROR,error: 'Error while adding favorite venue'
            });


    } catch(error) {
        yield put({
            type: ADD_FAVORITE_VENUE_ERROR,error: error.data
        });
    }
}


export function* addFavoriteVenueSagaWatcher() {
    yield takeLatest(ADD_FAVORITE_VENUE,addFavoriteVenueSaga);
}